import { API_URL, apiRequest } from './api';
import { Integration } from '../components/model';

const API_INTEGRATION_URL = `${API_URL}/integration`;

// Integrations API Methods
export const fetchAllIntegrations = async () => {
  return apiRequest('GET', API_INTEGRATION_URL);
};

export const fetchIntegrationByUuid = async (uuid: string) => {
  return apiRequest('GET', `${API_INTEGRATION_URL}/${uuid}`);
};

export const saveOrUpdateIntegration = async (
  integration: Integration
): Promise<Integration> => {
  return apiRequest(
    'POST',
    API_INTEGRATION_URL,
    integration
  ) as Promise<Integration>;
};

export const deleteIntegration = async (uuid: string) => {
  return apiRequest('DELETE', `${API_INTEGRATION_URL}/${uuid}`);
};

export const updateIntegrationStatus = async (
  uuid: string,
  status: 'ACTIVE' | 'INACTIVE'
) => {
  return apiRequest('PATCH', `${API_INTEGRATION_URL}/${uuid}/status`, status);
};

export const getActiveWebHook = async (uuid: string) => {
  return apiRequest('GET', `${API_INTEGRATION_URL}/${uuid}/tg-web-hook`);
};
